import { CaptureWebVitals } from "@mmt/web-vitals-logger";

/**
 * Web Vitals implementation - loaded as a separate chunk
 */
export const addWebVitalsScript = (sampleSpace = 100) => {
  const Event = new CaptureWebVitals(
    "web_vitals_values",
    sampleSpace,
    65871,
    "mmt_insurance_b2c_pdt_client_metric_logging",
    undefined,
    true
  );
  Event?.init(true, true, true, "");
};
